export const mouseCurrentPosition = {
	left: 0,
	top: 0
}

document.addEventListener('mousemove', e => {
	mouseCurrentPosition.left = e.x
	mouseCurrentPosition.top = e.y
})
